exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-wrapper[data-v-a4df3252] {\n  margin-bottom: 15px;\n  position: relative;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  border: 1px solid #d1d8dd;\n  border-radius: 35px;\n  overflow: hidden;\n  z-index: 1;\n}\n.input-icon[data-v-a4df3252] {\n  margin-left: 31px;\n  position: relative;\n  z-index: 1;\n  pointer-events: none;\n}\n.input[data-v-a4df3252] {\n  padding: 17px 31px 17px 54px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  border: none;\n  outline: none;\n  color: #3a4146;\n}\n.input[data-v-a4df3252]::placeholder {\n  color: #3a4146;\n}\n", ""]);

// exports
